<div>
    <mat-card
        appearance="outlined"
        class="flat mt-10"
    >
        <div class="row">
            <div class="col-xs-12">
                <div class="row">
                    <div class="header-space">
                        <div
                            style="margin-bottom: 10px"
                            data-tx-key="label.gb.device_data"
                        >
                            <h3 [id]="identifierService.labelId('viewDeviceTransmitInfo', 'deviceDataHeader')" class="merlin-header" >
                                {{ labels['label.gb.device_data'] }}
                            </h3>
                        </div>
                    </div>
                    <div class="pl-15">
                        <div (click)="openViewLeadsDialog()"
                             *ngIf="functionMode !== 'enroll' &&
                                   !patRes?.patientDevices?.[0]?.isICMDevice && 
                                   !isAveir"
                             [ngStyle]="{
                                color: 'black',
                                'pointer-events': 'auto',
                                cursor: 'pointer' }"
                        >
                            <p
                                [id]="identifierService.buttonId('viewDeviceTransmitInfo', 'viewLeads')"
                                class="sectionTitle popupLink"
                                data-tx-key="label.gb.view_leads"
                            >
                                {{ labels['label.gb.view_leads'] }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Get transferred patient implanting physician details -->
                <ng-container *ngIf="displayViewUI()">
                    <div class="row">
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'serialNumberLabel')"
                                class="labelText"
                                data-tx-key="label.gb.serial_number"
                            >
                                {{ labels['label.gb.serial_number'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'serialNumber'
                                    )
                                "
                            >
                                {{ getSerialNum() }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'devName')"
                                class="labelText"
                                data-tx-key="label.gb.dev_name"
                            >
                                {{ labels['label.gb.dev_name'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'enrollDeviceName'
                                    )
                                "
                            >
                                {{ getDeviceName() }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'implantDate')"
                                class="labelText"
                                data-tx-key="label.gb.implant_date"
                            >
                                {{ labels['label.gb.implant_date'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'viewImplantDate'
                                    )
                                "
                            >
                                {{ getImpDate() ? getImpDate() : "--" }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3"
                            *ngIf="showingPhysicalDropdownVal() || isAveirDevice()"
                        >
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'docPerformImplant')"
                                class="labelText"
                                data-tx-key="label.gb.doc_perform_implant"
                            >
                                {{ labels['label.gb.doc_perform_implant'] }}
                            </div>
                        <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="identifierService.dropdownId('device-transmit-information', 'docPerformImplant')"
                            >
                                <span [id]="identifierService.labelId('viewDeviceTransmitInfo', 'transPhysValue')" *ngIf="!isImplantPhysicianEditable">
                                  {{ getTransPatientImplantPhyIdData() ? getTransPatientImplantPhyIdData() : "--" }}
                                </span>
                                <span [id]="identifierService.labelId('viewDeviceTransmitInfo', 'implantPhysValue')" *ngIf="isImplantPhysicianEditable" >
                                    {{ getImplantingPhys() ? getImplantingPhys() : "--" }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-3 col-md-3 col-lg-3"
                            *ngIf="getTrueAAIInfoFlag()">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'leadChamber')"
                                class="labelText"
                                data-tx-key="label.gb.lead_chamber">
                                {{ labels['label.gb.lead_chamber'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'viewLeadChamber'
                                    )
                                "
                            >
                                {{ getChamb() ? getChamb() : "--" }}
                            </div>
                        </div>
                    </div>

                    <!-- DR Device Checkbox -->
                    <div class="row mt-5" style="padding: 1rem 1rem" *ngIf="displayViewUI() && isAveirDevice() && patRes?.patientDevices?.[1]">
                        <div class="ver-center">
                            <mat-checkbox
                                [disabled]="true"
                                [checked]="patRes?.patientDevices?.[1] ? true : false"
                                [id]="identifierService.dropdownId('device-transmit-information','drDevice')"
                                data-tx-key="label.gb.DR_chk"
                            >
                                {{ labels['label.gb.DR_chk'] }}
                            </mat-checkbox>
                        </div>
                    </div>


                    <!-- DR Device Fields -->
                    <div class="row" *ngIf="patRes?.patientDevices?.[1]">
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'drSerialNumber')"
                                class="labelText"
                                data-tx-key="label.gb.serial_number"
                            >
                                {{ labels['label.gb.serial_number'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drSerialNumber'
                                    )
                                "
                            >
                                {{ patRes?.patientDevices?.[1]?.serialNum || "--" }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'drDevName')"
                                class="labelText"
                                data-tx-key="label.gb.dev_name"
                            >
                                {{ labels['label.gb.dev_name'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drDeviceName'
                                    )
                                "
                            >
                                {{ patRes?.patientDevices?.[1]?.deviceFullDescription || "--" }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'drImplantDate')"
                                class="labelText"
                                data-tx-key="label.gb.implant_date"
                            >
                                {{ labels['label.gb.implant_date'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drImplantDate'
                                    )
                                "
                            >
                                {{ patRes?.patientDevices?.[1]?.implantDate || "--" }}
                            </div>
                        </div>
                        <div class="col-xs-3 col-md-3 col-lg-3">
                            <div
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'drDocPerformImplant')"
                                class="labelText"
                                data-tx-key="label.gb.doc_perform_implant"
                            >
                                {{ labels['label.gb.doc_perform_implant'] }}
                            </div>
                            <div
                                class="infoText"
                                style="margin-bottom: 10px"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'drImplantingPhysician'
                                    )
                                "
                            >
                                {{ getDrImplantingPhys() ? getDrImplantingPhys() : "--" }}
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="displayViewUI() && isAveirDevice() && patRes?.patientDevices?.[1]">
                        <div class="col-xs-12 ar-vr-device-hint" data-tx-key="label.gb.select_ar_vr_device">
                            <span [id]="identifierService.labelId('viewDeviceTransmitInfo', 'deviceLabelPrefix')" class="device-label-prefix">{{ labels['label.gb.device_label'] }}:&nbsp;</span>
                            <span [id]="identifierService.labelId('viewDeviceTransmitInfo', 'aveirPair')" class="device-label-text">{{ aveirPairLabel }}</span>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </mat-card>
    <ng-container *ngIf="!activatorClinicFlg">
        <mat-card
            appearance="outlined"
            class="flat mt-10"
            style="margin-bottom: 10px"
            *ngIf="showOrderTransmitterSection()"
        >
            <div class="row">
                <div class="col-xs-4 col-md-4 col-lg-4">
                    <div
                        [id]="identifierService.labelId('viewDeviceTransmitInfo', 'transmitterHeader')"
                        class="merlin-header"
                        style="margin-bottom: 10px"
                        data-tx-key="label.gb.transmitter"
                    >
                        {{ labels['label.gb.transmitter'] }}
                    </div>
                    <mat-radio-group
                        class="radio-group align-fields row"
                        *ngIf="
                            (!showPhysicianOpt && !isNGQCategory) ||
                            getTransmitterVisibleOnEmpty()
                        "
                        [disabled]="true"
                        [id]="
                            identifierService.dropdownId(
                                'device-transmit-information',
                                'transmitter'
                            )
                        "
                        [value]="patRes?.patient?.transmitterOrderFlg"
                    >
                        <div class="flex flex-row gap-4">
                            <mat-radio-button
                                [disabled]="true"
                                class="col-sm-1"
                                color="primary"
                                [value]="true"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'orderTransmit'
                                    )
                                "
                            ></mat-radio-button> &nbsp;
                            <span
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'orderTransmit')"
                                class="radioLabel"
                                data-tx-key="label.gb.order_transmit"
                            >
                                {{ labels['label.gb.order_transmit']}}
                            </span>
                        </div>
                        <br>
                        <div class="flex flex-row gap-4">
                            <mat-radio-button
                                [disabled]="true"
                                class="col-sm-1"
                                color="primary"
                                [value]="false"
                                [id]="
                                    identifierService.dropdownId(
                                        'device-transmit-information',
                                        'patHasTrans'
                                    )
                                "
                            ></mat-radio-button> &nbsp;
                            <span
                                [id]="identifierService.labelId('viewDeviceTransmitInfo', 'patHasTrans')"
                                class="radioLabel"
                                data-tx-key="label.gb.pat_has_trans"
                            >
                                {{ labels['label.gb.pat_has_trans'] }}
                            </span>
                        </div>
                    </mat-radio-group>
                    <span [id]="identifierService.labelId('viewDeviceTransmitInfo', 'orderTransmitterMsg')">
                        {{ orderTransmitterMsg }}
                    </span>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 orderDate">
                    <div [id]="identifierService.labelId('viewDeviceTransmitInfo', 'ordTrDate')" *ngIf="patRes?.patient?.transmitterOrderFlg && disableTransmitterRadioBtn()">
                        {{ getOrdTrDate() }}
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 col-lg-4 dataCollectionCheck">
                    <mat-checkbox
                        *ngIf="dataMiningFlg"
                        [disabled]="true"
                        [id]="
                        identifierService.dropdownId(
                            'device-transmit-information',
                            'dataMiningConsent'
                        )
                    "
                        data-tx-key="label.gb.record_data_collection_consent"
                        [(ngModel)]="patRes.patientDevices[0].dataMiningFlg"
                    >
                        {{ labels['label.gb.record_data_collection_consent'] }}
                    </mat-checkbox>
                </div>
            </div>
        </mat-card>
    </ng-container>
</div>
